import { Component, Input } from '@angular/core';
import { CONSTS } from './package-history-event.constants';

@Component({
  selector: 'app-package-history-event',
  templateUrl: './package-history-event.component.html',
  styleUrls: ['./package-history-event.component.scss'],
  standalone: false,
})
export class PackageHistoryEventComponent {
  @Input() eventTime!: string | null;
  @Input() sourceData!: string;
  @Input() eventType!: string;
  @Input() userIdData!: string;

  readonly CONSTANTS = CONSTS;
}
